import { Col } from "reactstrap";
import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { SettingsTypeService } from "../../services/SettingsTypeService";
import { SettingsTypeDTO } from "../../models/Settings/SettingsTypeDTO";

type SettingsV2NavBarProps = {
    childrenColumnSize?: number;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize?: number;
}

function TabPanel({ children, value, index, childrenColumnSize, ...other }: TabPanelProps) {
    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export function SettingsV2NavBar({ childrenColumnSize = 12, onTabChange }: SettingsV2NavBarProps & { onTabChange: (tabName: string) => void }) {
    const [activeTab, setActiveTab] = useState<number>(0);
    const [tabs, setTabs] = useState<SettingsTypeDTO[]>([]);
    const serviceSettingsType = new SettingsTypeService();

    useEffect(() => {
        async function fetchTypes() {
            const response = await serviceSettingsType.GetAll();
            if (response.success && response.obj) {
                // Ordena por index
                setTabs([...response.obj].sort((a, b) => a.index - b.index));
                // Chama o onTabChange para o primeiro tab
                if (response.obj.length > 0) {
                    onTabChange(response.obj[0].type);
                }
            }
        }
        fetchTypes();
        
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        if (tabs[newValue]) {
            onTabChange(tabs[newValue].type);
        }
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="settings v2 tabs"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    {tabs.map((tab, index) => (
                        <Tab key={tab.type} label={tab.type} {...a11yProps(index)} />
                    ))}
                </Tabs>
            </Box>

            {tabs.map((tab, index) => (
                <TabPanel key={tab.type} value={activeTab} index={index} childrenColumnSize={childrenColumnSize}>
                    <Box sx={{ marginTop: 2, marginLeft: 1 }}>
                        <p>{tab.description}</p>
                    </Box>
                </TabPanel>
            ))}
        </>
    );
}

export {};